import { Calendar } from 'primereact/calendar';
import './DateRangePicker.module.scss';

interface DateRangePickerProps {
  value: (Date | null)[] | null;
  onChange: (value: (Date | null)[] | null) => void;
}

const isEmptyRange = (val: (Date | null)[] | null): boolean => {
  if (!val) return true;
  if (!Array.isArray(val)) return true;
  return val[0] === null && val[1] === null;
};

const DateRangePicker = ({ value, onChange }: DateRangePickerProps) => {
  const displayValue = isEmptyRange(value) ? null : value;

  return (
    <Calendar
      value={displayValue}
      onChange={(e) => onChange(e.value ?? null)}
      selectionMode="range"
      showButtonBar
      dateFormat="dd/mm/yy"
      className="w-full"
      hideOnRangeSelection
      panelStyle={{ left: 0 }}
    />
  );
};

export default DateRangePicker;
